export default __webpack_public_path__ + "static/media/thumbnail_placeholder.68dab327.svg";